/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AdminNotification,
  AdminNotificationUnreadCount,
  AdminNotifications,
  AdminNotificationsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Admin Notifications list
 */
export const adminNotifications = (
    params?: MaybeRefOrGetter<AdminNotificationsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<AdminNotifications>(
      {url: `/notifications`, method: 'GET',
        params, signal
    },
      );
    }




export const getAdminNotificationsQueryKey = (params?: MaybeRefOrGetter<AdminNotificationsParams>,) => {
    return [
    'notifications', ...(params ? [params] : [])
    ] as const;
    }


export const getAdminNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof adminNotifications>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<AdminNotificationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotifications>>> = ({ signal }) => adminNotifications(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotifications>>, TError, TData>
}

export type AdminNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotifications>>>
export type AdminNotificationsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Admin Notifications list
 */

export function useAdminNotifications<TData = Awaited<ReturnType<typeof adminNotifications>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<AdminNotificationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete all Admin Notifications
 */
export const destroyAllAdminNotifications = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/notifications/destroy-all`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyAllAdminNotificationsMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAllAdminNotifications>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyAllAdminNotifications>>, TError,void, TContext> => {

const mutationKey = ['destroyAllAdminNotifications'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyAllAdminNotifications>>, void> = () => {


          return  destroyAllAdminNotifications()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyAllAdminNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAllAdminNotifications>>>

    export type DestroyAllAdminNotificationsMutationError = ErrorType<StandardError>

    /**
 * @summary Delete all Admin Notifications
 */
export const useDestroyAllAdminNotifications = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAllAdminNotifications>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyAllAdminNotifications>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroyAllAdminNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark all Admin Notifications as read
 */
export const readAllAdminNotifications = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/notifications/read-all`, method: 'PUT', signal
    },
      );
    }




export const getReadAllAdminNotificationsMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAllAdminNotifications>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof readAllAdminNotifications>>, TError,void, TContext> => {

const mutationKey = ['readAllAdminNotifications'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readAllAdminNotifications>>, void> = () => {


          return  readAllAdminNotifications()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReadAllAdminNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof readAllAdminNotifications>>>

    export type ReadAllAdminNotificationsMutationError = ErrorType<StandardError>

    /**
 * @summary Mark all Admin Notifications as read
 */
export const useReadAllAdminNotifications = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAllAdminNotifications>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof readAllAdminNotifications>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReadAllAdminNotificationsMutationOptions(options), queryClient);
    }
    /**
 * @summary Unread Admin Notification count
 */
export const adminNotificationsUnreadCount = (

 signal?: AbortSignal
) => {


      return axiosClient<AdminNotificationUnreadCount>(
      {url: `/notifications/unread-count`, method: 'GET', signal
    },
      );
    }




export const getAdminNotificationsUnreadCountQueryKey = () => {
    return [
    'notifications','unread-count'
    ] as const;
    }


export const getAdminNotificationsUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof adminNotificationsUnreadCount>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAdminNotificationsUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNotificationsUnreadCount>>> = ({ signal }) => adminNotificationsUnreadCount(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCount>>, TError, TData>
}

export type AdminNotificationsUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof adminNotificationsUnreadCount>>>
export type AdminNotificationsUnreadCountQueryError = ErrorType<StandardError>


/**
 * @summary Unread Admin Notification count
 */

export function useAdminNotificationsUnreadCount<TData = Awaited<ReturnType<typeof adminNotificationsUnreadCount>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminNotificationsUnreadCount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminNotificationsUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Admin Notification
 */
export const destroyAdminNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/notifications/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyAdminNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAdminNotification>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyAdminNotification>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyAdminNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyAdminNotification>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyAdminNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyAdminNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAdminNotification>>>

    export type DestroyAdminNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Delete Admin Notification
 */
export const useDestroyAdminNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAdminNotification>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyAdminNotification>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyAdminNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Archive Admin Notification
 */
export const archiveAdminNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminNotification>(
      {url: `/notifications/${id}/archive`, method: 'PUT', signal
    },
      );
    }




export const getArchiveAdminNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAdminNotification>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveAdminNotification>>, TError,{id: string}, TContext> => {

const mutationKey = ['archiveAdminNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveAdminNotification>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  archiveAdminNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveAdminNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof archiveAdminNotification>>>

    export type ArchiveAdminNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Archive Admin Notification
 */
export const useArchiveAdminNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAdminNotification>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof archiveAdminNotification>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getArchiveAdminNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark Admin Notification as read
 */
export const readAdminNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminNotification>(
      {url: `/notifications/${id}/read`, method: 'PUT', signal
    },
      );
    }




export const getReadAdminNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAdminNotification>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof readAdminNotification>>, TError,{id: string}, TContext> => {

const mutationKey = ['readAdminNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readAdminNotification>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  readAdminNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReadAdminNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof readAdminNotification>>>

    export type ReadAdminNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Mark Admin Notification as read
 */
export const useReadAdminNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAdminNotification>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof readAdminNotification>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getReadAdminNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Move Admin Notification back to the inbox
 */
export const unarchiveAdminNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminNotification>(
      {url: `/notifications/${id}/unarchive`, method: 'PUT', signal
    },
      );
    }




export const getUnarchiveAdminNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveAdminNotification>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveAdminNotification>>, TError,{id: string}, TContext> => {

const mutationKey = ['unarchiveAdminNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveAdminNotification>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  unarchiveAdminNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveAdminNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveAdminNotification>>>

    export type UnarchiveAdminNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Move Admin Notification back to the inbox
 */
export const useUnarchiveAdminNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveAdminNotification>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unarchiveAdminNotification>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUnarchiveAdminNotificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark Admin Notification as unread
 */
export const unreadAdminNotification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminNotification>(
      {url: `/notifications/${id}/unread`, method: 'PUT', signal
    },
      );
    }




export const getUnreadAdminNotificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreadAdminNotification>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unreadAdminNotification>>, TError,{id: string}, TContext> => {

const mutationKey = ['unreadAdminNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unreadAdminNotification>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  unreadAdminNotification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnreadAdminNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof unreadAdminNotification>>>

    export type UnreadAdminNotificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Mark Admin Notification as unread
 */
export const useUnreadAdminNotification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unreadAdminNotification>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unreadAdminNotification>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUnreadAdminNotificationMutationOptions(options), queryClient);
    }
